import { getInitialStructureNodeset } from "@src/cloud-connect/dependency-injection-container/get-initial-structure-nodeset";
import { getLogger } from "@src/cloud-connect/dependency-injection-container/get-logger";
import { OurNode } from "@src/cloud-connect/poc/our-node";

export class InitialCaretClickHandler {
  toggleExpanded(node: OurNode) {
    const logger = getLogger();
    const t0 = performance.now();
    logger.debug("t0 - start of action", t0);

    node.toggleNodeCollapse();

    const initialStructureNodeset = getInitialStructureNodeset();

    const rootNode = node.returnRootNodeFromOurNode();
    initialStructureNodeset.setRootNode(rootNode);
    const flatMap = rootNode.createMapFromOurNodeTree();
    initialStructureNodeset.setFlatMap(flatMap);

    // Notify observers of the change
    initialStructureNodeset.notifyObservers();

    const t1 = performance.now();
    logger.debug("t1 - end of action", t1);
    logger.debug(
      `Action to toggle expanded state of initial structure node in new structure took ${
        t1 - t0
      } milliseconds.`,
    );
  }
}
